export default {
    lang: {
        name: 'Wishlist'
    }
}